const getCsrfToken = () => { // should be moved outside and just stored here
  return document.querySelector('meta[name="csrf-token"]').getAttribute('content');
}

const getHeaders = (parameters) => {
  const headers = { "Content-Type": "application/json", "Accept": "application/json" };
  if (parameters.hasOwnProperty('method') && !['GET', 'OPTION'].includes(parameters.method)) {
    headers["X-CSRF-Token"] = getCsrfToken();
  }
  return Object.assign(headers, parameters.headers)
};

const apiHelper = {
  fetch: (url, parameters = {}) => {
    parameters.headers = getHeaders(parameters);
    if (parameters.hasOwnProperty('body')) {
      parameters.body = JSON.stringify(parameters.body);
    }
    return fetch(url, parameters)
      .then(response => {
        if (response.status === 401) {
          window.location.href = '/members/sign_in';
          return;
        }
        return response;
      })
      .catch(error => {
        console.log(error)
      });
  }
};

export default apiHelper;